import Vue from 'vue';
import axios from 'axios';

const feedActions = (pageCode) => {
    return {
        updateBettingPopup(context, data) {
            if ('maxStake' in data && data.maxStake !== null) {
                Object.keys(data.maxStake).forEach((uuid) => {
                    Object.keys(context.state.betFeedData).forEach((id) => {
                        if (context.state.betFeedData[id].uuid == uuid) {
                            let oddsMaxStake = context.state.betFeedData[id].oddsMaxStake ?? {};
                            let update = {
                                ...oddsMaxStake,
                                ...data['maxStake'][uuid],
                            };
                            Vue.set(context.state.betFeedData[id], 'oddsMaxStake', update);
                        }
                    });
                });
            }

            if ('extraOdds' in data && data.extraOdds !== null) {
                Object.keys(data.extraOdds).forEach((uuid) => {
                    Object.keys(context.state.betFeedData).forEach((id) => {
                        if (context.state.betFeedData[id].uuid == uuid) {
                            Object.keys(data['extraOdds'][uuid]).forEach((siteId) => {
                                let extraOddsLinesCount = Object.keys(data['extraOdds'][uuid][siteId]).length;
                                if (
                                    !context.state.betFeedData[id]['extraOddsLinesCount'] ||
                                    context.state.betFeedData[id]['extraOddsLinesCount'] < extraOddsLinesCount
                                ) {
                                    Vue.set(context.state.betFeedData[id], 'extraOddsLinesCount', extraOddsLinesCount);
                                }
                            });

                            Vue.set(context.state.betFeedData[id], 'extraOdds', data['extraOdds'][uuid]);
                        }
                    });
                });
            }
        },
    };
};

export default feedActions;
